import Vue from 'vue';
import VueRouter from 'vue-router';

import NotFoundRedirectRoute from './routes/404.route';
import AppointmentRoute from './routes/appointment.route';
import CompanyNotFoundRoute from './routes/company-not-found.route';
import NotFoundRoute from './routes/not-found.route';
import HomeRoute from './routes/home.route';

/**
 * Update Google Analytics with page-specific information
 *
 * @param {Route} to
 */
const hydrateGoogleAnalytics = to => {
  const trackingId = process.env.TRACKING_ID;
  const { gtag } = window;
  if (trackingId !== 'IGNORE' && gtag) { // Ignore during local development
    gtag('config', trackingId, {
      page_path: to.path,
      page_title: to.name,
    });
  }
};

const generateRouterConfig = () => ({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    HomeRoute,
    NotFoundRoute,
    CompanyNotFoundRoute,
    AppointmentRoute,
    NotFoundRedirectRoute,
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

const router = new VueRouter(generateRouterConfig());

router.afterEach(to => {
  hydrateGoogleAnalytics(to);
});

Vue.use(VueRouter);

export { hydrateGoogleAnalytics, generateRouterConfig };
export default router;
